import React from 'react'
import './DataSummary.scss'
import PrepareTooltip from 'components/shared/Tooltip'
import FlagIcon from 'components/shared/FlagIcon'


const DataSummary = (props) => {

    const { data } = props

    // A flagged value gets the same flag icon as the application list, with the reason on hover
    const flagIcon = (item) => item.flag && (
        <FlagIcon title={item.flag} style={{ marginLeft: 4, verticalAlign: 'middle' }} />
    );

    const tooltipDataGenerator = (item) => (
        item.values?.length
            ? <>{item.values.map((value, i) => <div key={i}>{value}</div>)}</>
            : null
    );

    return (
        <div className={`dataSummary ${props?.className || ''}`}>
            {
                (data && Array.isArray(data) ? data : []).map((item, index) => {

                    var tooltipData = tooltipDataGenerator(item);

                    return (
                        <div className='dataSummaryItem' key={index}>
                            {tooltipData ?
                                < PrepareTooltip title={tooltipData} placement="top-start" theme="white" arrow>
                                    <p className='dataSummaryField mb-0'>{item.field}</p>
                                    <p className='dataSummaryValue'>{item.value}{flagIcon(item)}</p>
                                </PrepareTooltip> :
                                <><p className='dataSummaryField mb-0'>{item.field}</p>
                                <p className='dataSummaryValue'>{item.value}{flagIcon(item)}</p>
                                </>
                            }

                        </div>
                    )
                })
            }
        </div>
    )
}

export default DataSummary
